<template>
  <div class="mul-choice mul-choice-simple">
    <div class="content-stem-simple">
      <span>{{ idx + 1 }}、</span>
      <span v-html="currentQuestion.smallContent[idx].content"/>
    </div>
    <div class="content-list-simple">
      <div class="content-option" v-for="(option, index) in currentQuestion.smallContent[idx].optionList"
           :key="index">
        <label>
          <input type="checkbox" name="multipleQuestion" :value="option.quesValue" @click="checkboxFn" :checked="hasAns(option.quesValue)">
          <strong>{{ option.quesValue }}.&nbsp;</strong>
          <span v-html="option.quesOption"/>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getCookie } from "@/utils"
  import { addFavoriteQues, getPlayAuxiliaryUrl } from '@/api'

  export default {
    name: 'ExamMultipleChoiceSimple',
    props: {
      idx: {
        type: Number
      }
    },
    computed: {
      ...mapGetters([
        'currentQuestion',
        'currentQuestionIndex'
      ]),
    },
    methods: {
      hasAns(old) {
        let userAns = this.currentQuestion.smallContent[this.idx].userAnswer
        let flag = false
        if(userAns){
          for(let item of userAns){
            if(old === item)flag = true
          }
        }
        return flag
      },
      checkboxFn(e) {
        this.$nextTick(() => {
          let _index = 0
          let value = JSON.parse(JSON.stringify(this.currentQuestion.smallContent[this.idx].userAnswer))

          if(value !== null){
            let isExist = value.some((item,idx) => {
              _index = idx
              return item === e.target.value
            })
            if(!isExist){
              value.push(e.target.value)
            }else{
              value.splice(_index,1)
            }
          }else{
            value = []
            value.push(e.target.value)
          }
          let isAnswer = value.length ? 1 : 0
          const data = {
            userAnswer: value,
            index: this.idx,
            isAnswer
          }
          this.$store.dispatch('setShortAns', data)
          this.$store.dispatch('setAttIsAns', data)

          let isAnswer_big = this.currentQuestion.smallContent.some(item => {
            return item.isAnswer === 1
          })
          if(isAnswer_big) {
            this.$store.dispatch('setIsAns', 1)
          }else{
            this.$store.dispatch('setIsAns', 0)
          }
        })
      }
    }
  }
</script>
